// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__z-iS_","title":"Header_title__2mL2H","side":"Header_side__3tsnW"};